export default {"src":"/_next/static/media/tab_home.f4e065cf.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};